var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnlockPage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M436.91,333.41s9.66,19.95,18.15,9.83-5.86-13.93-5.86-13.93,17.28,2.05,17.28-7.32-12.3-3.52-12.3-3.52,16-12.46,8.2-17.72c-5.42-3.65-18.45,9.56-18.45,9.56s5-12.92-.87-13.21-9.67,18.45-9.67,18.45-3.22-13.82-9.07-9.84,4.6,19.32,4.6,19.32-7.53-7.44-9.58-2.16,9.58,8.78,9.58,8.78.08,19.32,6.52,17S436.91,333.41,436.91,333.41Z",
    className: "svg-accent",
    style: {
      fill: "rgb(0, 109, 195)"
    },
    fill: "rgba(0,109,195,1)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M407.55,282s-23.11,1-21.66-11.38c1.21-10.34,17.57-3.43,17.57-3.43s-13.42-15.65-4.2-21.83S414,257.18,414,257.18s5.88-26,16.19-21.85c7.18,2.92-4.51,24.47-4.51,24.47s13.59-9.27,17.75-3.7-15.94,17.53-15.94,17.53,15.72-5.95,15.67,2.44-22.05,8.22-22.05,8.22,12.29,2.51,8.45,8-15-3.63-15-3.63-15.05,10.89-17,3S407.55,282,407.55,282Z",
    className: "svg-accent",
    style: {
      fill: "rgb(0, 109, 195)"
    },
    fill: "rgba(0,109,195,1)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M260.41,50.2h0A6.59,6.59,0,0,1,253.88,56H219.54A6.58,6.58,0,0,1,213,50.2h0a6.58,6.58,0,0,0-6.53-5.75H182.32A6.58,6.58,0,0,0,175.74,51V287.11a6.59,6.59,0,0,0,6.58,6.58H292.23a6.58,6.58,0,0,0,6.58-6.58V51a6.57,6.57,0,0,0-6.58-6.58H266.94A6.58,6.58,0,0,0,260.41,50.2Z",
    className: "svg-accent",
    style: {
      fill: "rgb(0, 109, 195)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    fill: "rgba(0,109,195,1)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M228.28,109.29,230.81,99l7,2.12,2.11,8.38a5.64,5.64,0,0,0,3,3.72,17.76,17.76,0,0,1,3,1.77s-8.34,10.69-24.35,0a16.36,16.36,0,0,1,3.42-1.91A5.52,5.52,0,0,0,228.28,109.29Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.09,211.42c2-4.86-2.89-19.56-5.08-25.59a2.27,2.27,0,0,0-3.65-.91c-2,1.77-4.39,5.21-4.79,11.59,0,0-15.26,26.87-15.26,39.13,0,11.49,22.72,35.42,22.72,35.42a10.61,10.61,0,0,0,6.06-4.86s-8.49-21-15.08-30C79,236.21,91.84,216.8,94.09,211.42Z",
    className: "svg-bg",
    style: {
      fill: "#3F3D56",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    fill: "#3F3D56"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.09,266.2s-3.52,14.56-2.13,46l.9,35.6s-5.06,25,4.65,70.26c0,0,3,6.7,15.09-1.68L114,347.33l12.65-76.27Z",
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.81,303.33c9,14.53,21.67,43.12,21.67,43.12s-1.91,3.31,0,8.86c0,0-5,19.31,2.25,65.48,0,0,6.24,4,15.26-3,0,0,4.5-69.4,2.77-78.76s-18-71.18-18-71.18H105",
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.55,177.83c8.93,1,24.5,3.15,23.57,27.16s-4.39,62.84-4.39,62.84S96.07,286.91,91,269.21c0,0,2.32-20-5.08-51.13S81.87,173.5,121.55,177.83Z",
    className: "svg-bg",
    style: {
      fill: "#3F3D56",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    fill: "#3F3D56"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125,178.27s15.47.1,22.4,4.26c0,0,12.25-2.08,17.11,0l4.39-16.41s5.78-2.78,8.55,1.38c0,0,2.08,25-1.38,27.05s-30.94,8.32-30.94,8.32S127.58,197.59,125,178.27Z",
    className: "svg-bg",
    style: {
      fill: "#3F3D56",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    fill: "#3F3D56"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "background-simple"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M442.33,98.13a92.74,92.74,0,0,0-6.25-11.63l0,0a.1.1,0,0,0,0,0c-13.7-19.62-38.69-38.23-84.26-39.17-97.88-2-69.46,162.88-193.85,177.78C39.73,239.19,29.12,354,66.31,393c52,47.71,103.49,68.7,215.91,64,86.11-3.57,142.11-20.77,169.35-54.87,17.08-21.39,25.27-49.35,28-83.74C485.86,238.63,461,138.56,442.33,98.13Z",
    className: "svg-accent",
    style: {
      fill: "rgb(0, 109, 195)"
    },
    fill: "rgba(0,109,195,1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.33,98.13a92.74,92.74,0,0,0-6.25-11.63l0,0a.1.1,0,0,0,0,0c-13.7-19.62-38.69-38.23-84.26-39.17-97.88-2-69.46,162.88-193.85,177.78C39.73,239.19,29.12,354,66.31,393c52,47.71,103.49,68.7,215.91,64,86.11-3.57,142.11-20.77,169.35-54.87,17.08-21.39,25.27-49.35,28-83.74C485.86,238.63,461,138.56,442.33,98.13Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shadow"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M451.57,402.2c-27.24,34.1-83.24,51.3-169.35,54.87-112.42,4.66-163.87-16.33-215.91-64h376Z",
    style: {
      fill: "#999"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Room"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 20.93,
    y1: 393.03,
    x2: 437.97,
    y2: 393.03,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "442.33 82.8 442.33 393.03 469.9 420.6",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Lamp"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 359.98,
    y1: 101.17,
    x2: 359.98,
    y2: 47.23,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.7,124.45a23.28,23.28,0,1,1,46.55,0Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("line", {
    x1: 66.31,
    y1: 393.03,
    x2: 47.25,
    y2: 393.03,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shelf"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 123.58,
    y: 268.8,
    width: 19.99,
    height: 124.24,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.66,
    y: 278.02,
    width: 80.77,
    height: 30.17,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.66,
    y: 311.48,
    width: 80.77,
    height: 30.17,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.66,
    y: 344.95,
    width: 80.77,
    height: 30.17,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.55,280.2a3.36,3.36,0,0,0,3.36,3.36H81.18a3.36,3.36,0,0,0,3.37-3.36",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.55,313.66A3.37,3.37,0,0,0,70.91,317H81.18a3.37,3.37,0,0,0,3.37-3.37",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.55,347.13a3.37,3.37,0,0,0,3.36,3.37H81.18a3.37,3.37,0,0,0,3.37-3.37",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "120.31 393.04 29.12 393.04 29.12 268.8 120.31 268.8",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Chair"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M198.2,332.72v47l24.61,8.67a1.57,1.57,0,0,1,1.05,1.48v1.46a1.56,1.56,0,0,1-2,1.5l-25.28-7.42-.46,6.07a1.66,1.66,0,0,1-1.67,1.55h-1.3a1.68,1.68,0,0,1-1.67-1.55l-.46-6.07-25.27,7.42a1.57,1.57,0,0,1-2-1.5v-1.46a1.57,1.57,0,0,1,1.05-1.48l24.62-8.67v-47",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 186.97,
    y1: 315.7,
    x2: 186.97,
    y2: 302.08,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 181.2,
    y1: 302.08,
    x2: 181.2,
    y2: 315.7,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162,299.66c-4.1-.16-7-2.82-7-7.42V268.39a7.46,7.46,0,0,1,4.75-6.61",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.87,265.37v26.77c0,4.62,3.69,7.17,8.34,6.35a68.13,68.13,0,0,1,30.52,1.34c4.58,1.24,8.18-1,8.18-5.6V267.46a6.13,6.13,0,0,0-3.83-5.38,70.57,70.57,0,0,0-39.3-1.73A5.46,5.46,0,0,0,160.87,265.37Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.75,317.68h-13.3a8.53,8.53,0,0,0-8.54,8.53h0a3.91,3.91,0,0,0,3.91,3.91h15.47",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.84,330.12h43.92a3.91,3.91,0,0,0,3.91-3.91h0a8.53,8.53,0,0,0-8.54-8.53H186.47a8.53,8.53,0,0,0-8.54,8.53h0A3.91,3.91,0,0,0,181.84,330.12Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Desk"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M388.63,247.84a2.17,2.17,0,0,0,2.11-1.91l4.38-40.77a1.68,1.68,0,0,0-1.7-1.91",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280.3,
    y: 272.27,
    width: 140.94,
    height: 13.08,
    transform: "translate(701.54 557.63) rotate(180)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "230.13 272.27 230.13 285.35 278.12 285.35",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "425.77 270.87 425.77 262.69 288.34 262.69",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.6,
    y: 262.69,
    width: 60.56,
    height: 8.18,
    transform: "translate(511.75 533.57) rotate(180)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "413.59 287.54 413.59 393.03 416.64 393.03 417.74 287.54",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "409.45 287.54 410.54 393.03 413.59 393.03 413.59 287.54",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "373.29 287.54 373.29 393.03 376.34 393.03 377.43 287.54",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "369.15 287.54 370.24 393.03 373.29 393.03 373.29 287.54",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "278.07 287.54 278.07 393.03 281.13 393.03 282.22 287.54",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "273.93 287.54 275.02 393.03 278.07 393.03 278.07 287.54",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "237.77 287.54 237.77 393.03 240.82 393.03 241.91 287.54",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "233.63 287.54 234.72 393.03 237.77 393.03 237.77 287.54",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311.31,
    y: 260.15,
    width: 29.65,
    height: 2.54,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.56,258.79h6.88a1.73,1.73,0,0,1,1.73,1.73v2.18a0,0,0,0,1,0,0H386.83a0,0,0,0,1,0,0v-2.18A1.73,1.73,0,0,1,388.56,258.79Z",
    transform: "translate(784.01 521.48) rotate(180)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.18,258.8c0-1.48-2.32-2.69-5.18-2.69s-5.17,1.21-5.17,2.69Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.83,258.8c0-1.48,2.32-2.69,5.17-2.69v2.69Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.48,247.84h-57.8a1.68,1.68,0,0,1-1.7-1.91l4.38-40.77a2.18,2.18,0,0,1,2.11-1.91h57.81a1.69,1.69,0,0,1,1.7,1.91l-4.38,40.77A2.17,2.17,0,0,1,386.48,247.84Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "365.94 248.93 366.93 258.11 369.11 258.11 368.12 248.93",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "351.76 248.93 352.75 258.11 366.93 258.11 365.94 248.93",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.07,244.89H331.73a1.46,1.46,0,0,1-1.48-1.66l3.8-35.37a1.89,1.89,0,0,1,1.84-1.66h52.34a1.46,1.46,0,0,1,1.48,1.66l-3.8,35.37A1.89,1.89,0,0,1,384.07,244.89Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 342.55,
    y: 258.11,
    width: 28.75,
    height: 4.59,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 371.3,
    y: 258.11,
    width: 8.41,
    height: 4.59,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.85,
    y: 214.85,
    width: 94.15,
    height: 21.21,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.23,227.68l-1.52-1.16.25,1.86a.85.85,0,0,1-.84,1h0a.85.85,0,0,1-.84-1l.25-1.86L320,227.68a.85.85,0,0,1-1.24-.25l0,0a.84.84,0,0,1,.4-1.2l1.75-.73-1.75-.73a.85.85,0,0,1-.4-1.21l0,0a.84.84,0,0,1,1.24-.25l1.52,1.16-.25-1.86a.85.85,0,0,1,.84-1h0a.85.85,0,0,1,.84,1l-.25,1.86,1.52-1.16a.84.84,0,0,1,1.24.25l0,0a.85.85,0,0,1-.4,1.21l-1.75.73,1.75.73a.84.84,0,0,1,.4,1.2l0,0A.85.85,0,0,1,324.23,227.68Z",
    className: "svg-bg",
    style: {
      fill: "#3F3D56"
    },
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.8,227.68l-1.52-1.16.25,1.86a.85.85,0,0,1-.84,1h0a.84.84,0,0,1-.83-1l.25-1.86-1.52,1.16a.86.86,0,0,1-1.25-.25l0,0a.85.85,0,0,1,.41-1.2l1.74-.73-1.74-.73a.86.86,0,0,1-.41-1.21l0,0a.85.85,0,0,1,1.25-.25l1.52,1.16-.25-1.86a.84.84,0,0,1,.83-1h0a.85.85,0,0,1,.84,1l-.25,1.86,1.52-1.16a.84.84,0,0,1,1.24.25l0,0a.85.85,0,0,1-.4,1.21l-1.74.73,1.74.73a.84.84,0,0,1,.4,1.2l0,0A.85.85,0,0,1,337.8,227.68Z",
    className: "svg-bg",
    style: {
      fill: "#3F3D56"
    },
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.37,227.68l-1.52-1.16.25,1.86a.84.84,0,0,1-.83,1h0a.84.84,0,0,1-.84-1l.25-1.86-1.52,1.16a.85.85,0,0,1-1.24-.25l0,0a.84.84,0,0,1,.4-1.2l1.74-.73-1.74-.73a.85.85,0,0,1-.4-1.21l0,0a.84.84,0,0,1,1.24-.25l1.52,1.16-.25-1.86a.84.84,0,0,1,.84-1h0a.84.84,0,0,1,.83,1l-.25,1.86,1.52-1.16a.84.84,0,0,1,1.24.25l0,0a.86.86,0,0,1-.41,1.21l-1.74.73,1.74.73a.84.84,0,0,1,.4,1.2l0,0A.85.85,0,0,1,351.37,227.68Z",
    className: "svg-bg",
    style: {
      fill: "#3F3D56"
    },
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365,227.68l-1.53-1.16.25,1.86a.84.84,0,0,1-.83,1h0a.85.85,0,0,1-.84-1l.25-1.86-1.52,1.16a.85.85,0,0,1-1.24-.25l0,0a.84.84,0,0,1,.4-1.2l1.75-.73-1.75-.73a.85.85,0,0,1-.4-1.21l0,0a.84.84,0,0,1,1.24-.25l1.52,1.16-.25-1.86a.85.85,0,0,1,.84-1h0a.84.84,0,0,1,.83,1l-.25,1.86,1.53-1.16a.84.84,0,0,1,1.24.25l0,0a.86.86,0,0,1-.4,1.21l-1.75.73,1.74.73a.85.85,0,0,1,.41,1.2l0,0A.85.85,0,0,1,365,227.68Z",
    className: "svg-bg",
    style: {
      fill: "#3F3D56"
    },
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.52,227.68,377,226.52l.25,1.86a.85.85,0,0,1-.84,1h0a.85.85,0,0,1-.84-1l.25-1.86-1.52,1.16a.85.85,0,0,1-1.24-.25l0,0a.84.84,0,0,1,.4-1.2l1.75-.73-1.75-.73a.85.85,0,0,1-.4-1.21l0,0a.84.84,0,0,1,1.24-.25l1.52,1.16-.25-1.86a.85.85,0,0,1,.84-1h0a.85.85,0,0,1,.84,1L377,224.4l1.52-1.16a.84.84,0,0,1,1.24.25l0,0a.85.85,0,0,1-.4,1.21l-1.75.73,1.75.73a.84.84,0,0,1,.4,1.2l0,0A.85.85,0,0,1,378.52,227.68Z",
    className: "svg-bg",
    style: {
      fill: "#3F3D56"
    },
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.21,225.46s-2.77,3.45-6.18,3.45-6.17-3.45-6.17-3.45S391.62,222,395,222,401.21,225.46,401.21,225.46Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.16,225.46a2.13,2.13,0,1,1-2.13-2.12A2.12,2.12,0,0,1,397.16,225.46Z",
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plant"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M377.38,317.86s-11.45,23.65-21.51,11.65,6.94-16.5,6.94-16.5-20.48,2.42-20.48-8.68,14.58-4.16,14.58-4.16-18.94-14.77-9.72-21c6.42-4.34,21.86,11.33,21.86,11.33s-5.9-15.32,1-15.67,11.46,21.87,11.46,21.87,3.81-16.37,10.75-11.66-5.45,22.89-5.45,22.89,8.92-8.81,11.35-2.56-11.35,10.41-11.35,10.41-.1,22.91-7.73,20.13S377.38,317.86,377.38,317.86Z",
    className: "svg-accent",
    style: {
      fill: "rgb(0, 109, 195)"
    },
    fill: "rgba(0,109,195,1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.79,369.22s0-52.74-31.38-68.71",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.63,308.93s-8.76,1.56-18.65,12.32",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.5,303.61s-9.66,2.95-19,1.88",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.22,305.72a28.68,28.68,0,0,0,10.27-12.23",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.91,333.41s9.66,19.95,18.15,9.83-5.86-13.93-5.86-13.93,17.28,2.05,17.28-7.32-12.3-3.52-12.3-3.52,16-12.46,8.2-17.72c-5.42-3.65-18.45,9.56-18.45,9.56s5-12.92-.87-13.21-9.67,18.45-9.67,18.45-3.22-13.82-9.07-9.84,4.6,19.32,4.6,19.32-7.53-7.44-9.58-2.16,9.58,8.78,9.58,8.78.08,19.32,6.52,17S436.91,333.41,436.91,333.41Z",
    className: "svg-accent",
    style: {
      fill: "rgb(0, 109, 195)"
    },
    fill: "rgba(0,109,195,1)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M436.91,333.41s9.66,19.95,18.15,9.83-5.86-13.93-5.86-13.93,17.28,2.05,17.28-7.32-12.3-3.52-12.3-3.52,16-12.46,8.2-17.72c-5.42-3.65-18.45,9.56-18.45,9.56s5-12.92-.87-13.21-9.67,18.45-9.67,18.45-3.22-13.82-9.07-9.84,4.6,19.32,4.6,19.32-7.53-7.44-9.58-2.16,9.58,8.78,9.58,8.78.08,19.32,6.52,17S436.91,333.41,436.91,333.41Z",
    style: {
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M435.74,322.42h0c-13.65,9.85-15.6,44-15.6,44",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.71,326.38a39.29,39.29,0,0,1,14.51,9.76",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.15,305.72c0,7.46-4.42,16.7-4.42,16.7l3.24,1",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.64,324.22s8.23,1.84,14.47,0",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.55,282s-23.11,1-21.66-11.38c1.21-10.34,17.57-3.43,17.57-3.43s-13.42-15.65-4.2-21.83S414,257.18,414,257.18s5.88-26,16.19-21.85c7.18,2.92-4.51,24.47-4.51,24.47s13.59-9.27,17.75-3.7-15.94,17.53-15.94,17.53,15.72-5.95,15.67,2.44-22.05,8.22-22.05,8.22,12.29,2.51,8.45,8-15-3.63-15-3.63-15.05,10.89-17,3S407.55,282,407.55,282Z",
    className: "svg-accent",
    style: {
      fill: "rgb(0, 109, 195)"
    },
    fill: "rgba(0,109,195,1)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path-2)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M407.55,282s-23.11,1-21.66-11.38c1.21-10.34,17.57-3.43,17.57-3.43s-13.42-15.65-4.2-21.83S414,257.18,414,257.18s5.88-26,16.19-21.85c7.18,2.92-4.51,24.47-4.51,24.47s13.59-9.27,17.75-3.7-15.94,17.53-15.94,17.53,15.72-5.95,15.67,2.44-22.05,8.22-22.05,8.22,12.29,2.51,8.45,8-15-3.63-15-3.63-15.05,10.89-17,3S407.55,282,407.55,282Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M410.74,369.22s-3.69-65.28,9.39-109",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.69,272.14s9.74-.82,21.25,5.5",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.79,251.58s9.74,9.54,13.71,23.25",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.37,270.79s6.33-7,14.34-8.8",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.53,362.76H385.76l4,45.13a1.91,1.91,0,0,0,1.9,1.74h0l1,11.15a1.92,1.92,0,0,0,1.91,1.74h32.15a1.91,1.91,0,0,0,1.9-1.74l1-11.15h0a1.92,1.92,0,0,0,1.91-1.74Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.85,366.45H385.44a3.57,3.57,0,0,1-3.56-3.56h0a3.57,3.57,0,0,1,3.56-3.56h50.41a3.56,3.56,0,0,1,3.55,3.56h0A3.56,3.56,0,0,1,435.85,366.45Z",
    className: "svg-bg",
    style: {
      fill: "#3F3D56",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 420.44,
    y1: 409.76,
    x2: 423.74,
    y2: 409.76,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 397.54,
    y1: 409.76,
    x2: 417.13,
    y2: 409.76,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Device"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M300.26,38.73H286.63V299.41h13.63a8.19,8.19,0,0,0,8.18-8.19V46.92A8.19,8.19,0,0,0,300.26,38.73Z",
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.47,
    y: 38.73,
    width: 133.61,
    height: 260.68,
    rx: 7.5,
    className: "svg-bg",
    style: {
      fill: "#3F3D56",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.41,50.2h0A6.59,6.59,0,0,1,253.88,56H219.54A6.58,6.58,0,0,1,213,50.2h0a6.58,6.58,0,0,0-6.53-5.75H182.32A6.58,6.58,0,0,0,175.74,51V287.11a6.59,6.59,0,0,0,6.58,6.58H292.23a6.58,6.58,0,0,0,6.58-6.58V51a6.57,6.57,0,0,0-6.58-6.58H266.94A6.58,6.58,0,0,0,260.41,50.2Z",
    className: "svg-accent",
    style: {
      fill: "rgb(0, 109, 195)"
    },
    fill: "rgba(0,109,195,1)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path-3)"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "211.99 310.27 171.83 310.27 268.64 25.27 308.8 25.27 211.99 310.27",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "240.07 310.27 229.39 310.27 326.21 25.27 336.89 25.27 240.07 310.27",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M260.41,50.2h0A6.59,6.59,0,0,1,253.88,56H219.54A6.58,6.58,0,0,1,213,50.2h0a6.58,6.58,0,0,0-6.53-5.75H182.32A6.58,6.58,0,0,0,175.74,51V287.11a6.59,6.59,0,0,0,6.58,6.58H292.23a6.58,6.58,0,0,0,6.58-6.58V51a6.57,6.57,0,0,0-6.58-6.58H266.94A6.58,6.58,0,0,0,260.41,50.2Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.46,47.83a3,3,0,1,1-3-3A3,3,0,0,1,225.46,47.83Z",
    className: "svg-accent",
    style: {
      fill: "rgb(0, 109, 195)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    fill: "rgba(0,109,195,1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.18,44.92H234a2.91,2.91,0,0,0,0,5.82h15.18a2.91,2.91,0,0,0,0-5.82Z",
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251,280.87H221.82a3,3,0,1,0,0,6H251a3,3,0,1,0,0-6Z",
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.93,105.07V85.57a1.63,1.63,0,0,0-3.26,0v19.5a1.63,1.63,0,0,0,3.26,0Z",
    className: "svg-bg",
    style: {
      fill: "#3F3D56"
    },
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.93,119.55v-6.49a1.63,1.63,0,0,0-3.26,0v6.49a1.63,1.63,0,1,0,3.26,0Z",
    className: "svg-bg",
    style: {
      fill: "#3F3D56"
    },
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165.85,
    y: 133.93,
    width: 147.11,
    height: 33.14,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.63,154l-2.38-1.81.39,2.91a1.32,1.32,0,0,1-1.3,1.5h0a1.32,1.32,0,0,1-1.31-1.5l.39-2.91L177,154a1.32,1.32,0,0,1-1.94-.38l0-.06a1.32,1.32,0,0,1,.63-1.88l2.73-1.14-2.73-1.15a1.32,1.32,0,0,1-.63-1.88l0-.05A1.32,1.32,0,0,1,177,147l2.38,1.81-.39-2.91a1.31,1.31,0,0,1,1.31-1.49h0a1.31,1.31,0,0,1,1.3,1.49l-.39,2.91,2.38-1.81a1.32,1.32,0,0,1,1.94.39l0,.05a1.32,1.32,0,0,1-.63,1.88l-2.73,1.15,2.73,1.14a1.32,1.32,0,0,1,.63,1.88l0,.06A1.32,1.32,0,0,1,183.63,154Z",
    className: "svg-bg",
    style: {
      fill: "#3F3D56"
    },
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.84,154l-2.38-1.81.39,2.91a1.33,1.33,0,0,1-1.31,1.5h0a1.32,1.32,0,0,1-1.3-1.5l.38-2.91L198.25,154a1.32,1.32,0,0,1-1.94-.38l0-.06a1.32,1.32,0,0,1,.63-1.88l2.72-1.14-2.72-1.15a1.32,1.32,0,0,1-.63-1.88l0-.05a1.32,1.32,0,0,1,1.94-.39l2.37,1.81-.38-2.91a1.31,1.31,0,0,1,1.3-1.49h0a1.32,1.32,0,0,1,1.31,1.49l-.39,2.91,2.38-1.81a1.31,1.31,0,0,1,1.93.39l0,.05a1.32,1.32,0,0,1-.63,1.88l-2.73,1.15,2.73,1.14a1.32,1.32,0,0,1,.63,1.88l0,.06A1.31,1.31,0,0,1,204.84,154Z",
    className: "svg-bg",
    style: {
      fill: "#3F3D56"
    },
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226,154l-2.37-1.81.39,2.91a1.33,1.33,0,0,1-1.31,1.5h0a1.33,1.33,0,0,1-1.31-1.5l.39-2.91L219.46,154a1.32,1.32,0,0,1-1.94-.38l0-.06a1.32,1.32,0,0,1,.63-1.88l2.73-1.14-2.73-1.15a1.32,1.32,0,0,1-.63-1.88l0-.05a1.32,1.32,0,0,1,1.94-.39l2.37,1.81-.39-2.91a1.32,1.32,0,0,1,1.31-1.49h0a1.32,1.32,0,0,1,1.31,1.49l-.39,2.91L226,147a1.32,1.32,0,0,1,1.94.39l0,.05a1.31,1.31,0,0,1-.62,1.88l-2.73,1.15,2.72,1.14a1.32,1.32,0,0,1,.63,1.88l0,.06A1.32,1.32,0,0,1,226,154Z",
    className: "svg-bg",
    style: {
      fill: "#3F3D56"
    },
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.25,154l-2.38-1.81.39,2.91a1.32,1.32,0,0,1-1.3,1.5h0a1.32,1.32,0,0,1-1.31-1.5l.39-2.91L240.66,154a1.32,1.32,0,0,1-1.94-.38l0-.06a1.32,1.32,0,0,1,.63-1.88l2.73-1.14-2.73-1.15a1.32,1.32,0,0,1-.63-1.88l0-.05a1.32,1.32,0,0,1,1.94-.39l2.38,1.81-.39-2.91a1.31,1.31,0,0,1,1.31-1.49h0a1.31,1.31,0,0,1,1.3,1.49l-.39,2.91,2.38-1.81a1.32,1.32,0,0,1,1.94.39l0,.05a1.32,1.32,0,0,1-.63,1.88l-2.72,1.15,2.72,1.14a1.32,1.32,0,0,1,.63,1.88l0,.06A1.32,1.32,0,0,1,247.25,154Z",
    className: "svg-bg",
    style: {
      fill: "#3F3D56"
    },
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.46,154l-2.38-1.81.39,2.91a1.33,1.33,0,0,1-1.31,1.5h0a1.32,1.32,0,0,1-1.3-1.5l.38-2.91L261.87,154a1.32,1.32,0,0,1-1.94-.38l0-.06a1.32,1.32,0,0,1,.63-1.88l2.72-1.14-2.72-1.15a1.32,1.32,0,0,1-.63-1.88l0-.05a1.32,1.32,0,0,1,1.94-.39l2.37,1.81-.38-2.91a1.31,1.31,0,0,1,1.3-1.49h0a1.32,1.32,0,0,1,1.31,1.49l-.39,2.91,2.38-1.81a1.31,1.31,0,0,1,1.93.39l0,.05a1.32,1.32,0,0,1-.63,1.88l-2.73,1.15,2.73,1.14a1.32,1.32,0,0,1,.63,1.88l0,.06A1.31,1.31,0,0,1,268.46,154Z",
    className: "svg-bg",
    style: {
      fill: "#3F3D56"
    },
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.91,150.5s-4.32,5.39-9.65,5.39-9.64-5.39-9.64-5.39,4.31-5.4,9.64-5.4S303.91,150.5,303.91,150.5Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.58,150.5a3.32,3.32,0,1,1-3.32-3.32A3.32,3.32,0,0,1,297.58,150.5Z",
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.74,
    y: 183.62,
    width: 16.71,
    height: 19.24,
    rx: 3.97,
    className: "svg-accent",
    style: {
      fill: "rgb(0, 109, 195)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    fill: "rgba(0,109,195,1)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.38,
    y: 183.62,
    width: 16.71,
    height: 19.24,
    rx: 3.97,
    className: "svg-accent",
    style: {
      fill: "rgb(0, 109, 195)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    fill: "rgba(0,109,195,1)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.01,
    y: 183.62,
    width: 16.71,
    height: 19.24,
    rx: 3.97,
    className: "svg-accent",
    style: {
      fill: "rgb(0, 109, 195)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    fill: "rgba(0,109,195,1)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.64,
    y: 183.62,
    width: 16.71,
    height: 19.24,
    rx: 3.97,
    className: "svg-accent",
    style: {
      fill: "rgb(0, 109, 195)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    fill: "rgba(0,109,195,1)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.28,
    y: 183.62,
    width: 16.71,
    height: 19.24,
    rx: 3.97,
    className: "svg-accent",
    style: {
      fill: "rgb(0, 109, 195)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    fill: "rgba(0,109,195,1)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274.91,
    y: 183.62,
    width: 16.71,
    height: 19.24,
    rx: 3.97,
    className: "svg-accent",
    style: {
      fill: "rgb(0, 109, 195)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    fill: "rgba(0,109,195,1)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191.06,
    y: 205.92,
    width: 16.71,
    height: 19.24,
    rx: 3.97,
    className: "svg-accent",
    style: {
      fill: "rgb(0, 109, 195)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    fill: "rgba(0,109,195,1)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.69,
    y: 205.92,
    width: 16.71,
    height: 19.24,
    rx: 3.97,
    className: "svg-accent",
    style: {
      fill: "rgb(0, 109, 195)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    fill: "rgba(0,109,195,1)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.33,
    y: 205.92,
    width: 16.71,
    height: 19.24,
    rx: 3.97,
    className: "svg-accent",
    style: {
      fill: "rgb(0, 109, 195)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    fill: "rgba(0,109,195,1)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246.96,
    y: 205.92,
    width: 16.71,
    height: 19.24,
    rx: 3.97,
    className: "svg-accent",
    style: {
      fill: "rgb(0, 109, 195)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    fill: "rgba(0,109,195,1)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265.59,
    y: 205.92,
    width: 16.71,
    height: 19.24,
    rx: 3.97,
    className: "svg-accent",
    style: {
      fill: "rgb(0, 109, 195)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    fill: "rgba(0,109,195,1)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.74,
    y: 228.22,
    width: 16.71,
    height: 19.24,
    rx: 3.97,
    className: "svg-accent",
    style: {
      fill: "rgb(0, 109, 195)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    fill: "rgba(0,109,195,1)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.38,
    y: 228.22,
    width: 16.71,
    height: 19.24,
    rx: 3.97,
    className: "svg-accent",
    style: {
      fill: "rgb(0, 109, 195)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    fill: "rgba(0,109,195,1)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.01,
    y: 228.22,
    width: 16.71,
    height: 19.24,
    rx: 3.97,
    className: "svg-accent",
    style: {
      fill: "rgb(0, 109, 195)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    fill: "rgba(0,109,195,1)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.64,
    y: 228.22,
    width: 16.71,
    height: 19.24,
    rx: 3.97,
    className: "svg-accent",
    style: {
      fill: "rgb(0, 109, 195)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    fill: "rgba(0,109,195,1)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.28,
    y: 228.22,
    width: 16.71,
    height: 19.24,
    rx: 3.97,
    className: "svg-accent",
    style: {
      fill: "rgb(0, 109, 195)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    fill: "rgba(0,109,195,1)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274.91,
    y: 228.22,
    width: 16.71,
    height: 19.24,
    rx: 3.97,
    className: "svg-accent",
    style: {
      fill: "rgb(0, 109, 195)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    fill: "rgba(0,109,195,1)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191.06,
    y: 250.52,
    width: 16.71,
    height: 19.24,
    rx: 3.97,
    className: "svg-accent",
    style: {
      fill: "rgb(0, 109, 195)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    fill: "rgba(0,109,195,1)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.69,
    y: 250.52,
    width: 16.71,
    height: 19.24,
    rx: 3.97,
    className: "svg-accent",
    style: {
      fill: "rgb(0, 109, 195)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    fill: "rgba(0,109,195,1)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.33,
    y: 250.52,
    width: 16.71,
    height: 19.24,
    rx: 3.97,
    className: "svg-accent",
    style: {
      fill: "rgb(0, 109, 195)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    fill: "rgba(0,109,195,1)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246.96,
    y: 250.52,
    width: 16.71,
    height: 19.24,
    rx: 3.97,
    className: "svg-accent",
    style: {
      fill: "rgb(0, 109, 195)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    fill: "rgba(0,109,195,1)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265.59,
    y: 250.52,
    width: 16.71,
    height: 19.24,
    rx: 3.97,
    className: "svg-accent",
    style: {
      fill: "rgb(0, 109, 195)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    fill: "rgba(0,109,195,1)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 236.43,
    cy: 94.23,
    r: 27.86,
    transform: "translate(42.32 258.85) rotate(-62.03)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.43,122.08a27.66,27.66,0,0,0,16.85-5.68,59.53,59.53,0,0,0-20.4-3.72,43.5,43.5,0,0,0-14.62,2.65A27.77,27.77,0,0,0,236.43,122.08Z",
    className: "svg-accent",
    style: {
      fill: "rgb(0, 109, 195)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    fill: "rgba(0,109,195,1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.93,106.65s-.24-9.08-2.79-15.72-4-16.45,5.73-17.81,13.58.25,19.15-.19c10.7-.83-1.09,11.46-1.09,11.46L235.6,90S230.63,107.09,228.93,106.65Z",
    className: "svg-bg",
    style: {
      fill: "#3F3D56",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.28,109.29,230.81,99l7,2.12,2.11,8.38a5.64,5.64,0,0,0,3,3.72,17.76,17.76,0,0,1,3,1.77s-8.34,10.69-24.35,0a16.36,16.36,0,0,1,3.42-1.91A5.52,5.52,0,0,0,228.28,109.29Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path-4)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M250.15,84.71l.92,6.13a4.36,4.36,0,0,1-.16,1.93l-.53,1.67.31,4a4.28,4.28,0,0,1,0,.62c-.14,2-1.13,11.82-7,12.27-5.23.4-10.45-5-12.3-7.56a6.33,6.33,0,0,1-1-2.12l-.79-3.11a3.53,3.53,0,0,1-3.34-2.46c-.79-2.51-2.1-4.13.44-5.38S230.12,93,230.12,93s.66-4.13,1.36-5.31,2.86-2.3,3.52-3.31a14.94,14.94,0,0,0,.9-2.49s7.73,1.49,13.6.3Z",
    className: "svg-bg",
    style: {
      fill: "#3F3D56",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    fill: "#3F3D56"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M228.28,109.29,230.81,99l7,2.12,2.11,8.38a5.64,5.64,0,0,0,3,3.72,17.76,17.76,0,0,1,3,1.77s-8.34,10.69-24.35,0a16.36,16.36,0,0,1,3.42-1.91A5.52,5.52,0,0,0,228.28,109.29Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.15,83.62l.92,6.13a4.37,4.37,0,0,1-.16,1.93l-.53,1.67.31,4a4.44,4.44,0,0,1,0,.63c-.14,2-1.13,11.82-7,12.27-5.23.4-10.45-5-12.3-7.56a6.43,6.43,0,0,1-1-2.12l-.79-3.11A3.53,3.53,0,0,1,226.24,95c-.79-2.51-2.1-4.13.44-5.38s3.44,2.28,3.44,2.28.66-4.13,1.36-5.31,2.86-2.3,3.52-3.31a14.94,14.94,0,0,0,.9-2.49s7.73,1.49,13.6.3Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246,93.85l1.92,4.64a1,1,0,0,1-.89,1.42l-2.39.16",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.05,101.8a3,3,0,0,0,4.47,1.11",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240,76.3c-10.36-1.18-12.27,2.91-12.27,2.91",
    style: {
      fill: "none",
      stroke: "#7f7f7f",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.37,75.17a39.26,39.26,0,0,1-9.09,1.17",
    style: {
      fill: "none",
      stroke: "#7f7f7f",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242,79.28c2.95,0,8.91-.55,11.29-3.27",
    style: {
      fill: "none",
      stroke: "#7f7f7f",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.64,78.78a18.83,18.83,0,0,0,2.32.38",
    style: {
      fill: "none",
      stroke: "#7f7f7f",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.84,93.18c0,.8-.32,1.44-.72,1.44s-.72-.64-.72-1.44.33-1.44.72-1.44S241.84,92.39,241.84,93.18Z",
    className: "svg-bg",
    style: {
      fill: "#3F3D56"
    },
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.62,93c0,.69-.28,1.25-.62,1.25s-.63-.56-.63-1.25.28-1.25.63-1.25S248.62,92.3,248.62,93Z",
    className: "svg-bg",
    style: {
      fill: "#3F3D56"
    },
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.77,91.06s.86-2.57,2.35-2.5a2.7,2.7,0,0,1,2.17,1.5",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.09,90c-.28-.69-.71-1.47-1.28-1.43-1,.06-1.49,1.5-1.49,1.5",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Character"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.09,211.42c2-4.86-2.89-19.56-5.08-25.59a2.27,2.27,0,0,0-3.65-.91c-2,1.77-4.39,5.21-4.79,11.59,0,0-15.26,26.87-15.26,39.13,0,11.49,22.72,35.42,22.72,35.42a10.61,10.61,0,0,0,6.06-4.86s-8.49-21-15.08-30C79,236.21,91.84,216.8,94.09,211.42Z",
    className: "svg-bg",
    style: {
      fill: "#3F3D56"
    },
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path-5)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.54,219.28s-7.27-15.49-10-14.1-9.81,27.51-7.1,31.67,17.49,33.53,21.19,32.94S91.54,219.28,91.54,219.28Z",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M94.09,211.42c2-4.86-2.89-19.56-5.08-25.59a2.27,2.27,0,0,0-3.65-.91c-2,1.77-4.39,5.21-4.79,11.59,0,0-15.26,26.87-15.26,39.13,0,11.49,22.72,35.42,22.72,35.42a10.61,10.61,0,0,0,6.06-4.86s-8.49-21-15.08-30C79,236.21,91.84,216.8,94.09,211.42Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.16,264.3l3.43,5.49s10.68,3.34,11.79,6.87-4.36,8.45-7.61,7.46-8.55-10.79-8.55-10.79l-4.32-5Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.43,269.67l2.31,2.66a13.19,13.19,0,0,0,7.76-5.92l-1.4-3.33S92.13,267.7,85.43,269.67Z",
    className: "svg-accent",
    style: {
      fill: "rgb(0, 109, 195)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    fill: "rgba(0,109,195,1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.12,416.85l-3,12.45a2.84,2.84,0,0,0,2.76,3.5H116.4a2.85,2.85,0,0,0,2.81-3.33,6.78,6.78,0,0,0-2.92-4.65c-4-2.6-5.9-10.74-5.9-10.74Z",
    className: "svg-bg",
    style: {
      fill: "#3F3D56",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.29,418.93S139.46,423,139,430.26a2.43,2.43,0,0,0,2.43,2.54h31.07a2.92,2.92,0,0,0,1.84-5.2,9,9,0,0,0-4.53-1.74c-7.62-1-14.37-4.5-15.59-9Z",
    className: "svg-bg",
    style: {
      fill: "#3F3D56",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.09,266.2s-3.52,14.56-2.13,46l.9,35.6s-5.06,25,4.65,70.26c0,0,3,6.7,15.09-1.68L114,347.33l12.65-76.27Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path-6)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.25,298.33s-5.16,20.57-7.24,32.59-14.45,11.1-15.94,19,13-1.39,11.59,27-6.48,43.91,1.48,43.68S117.33,398,117.33,398l4.85-68.18v-9.48l1.16-18Z",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M94.09,266.2s-3.52,14.56-2.13,46l.9,35.6s-5.06,25,4.65,70.26c0,0,3,6.7,15.09-1.68L114,347.33l12.65-76.27Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.07,355.52a23.78,23.78,0,0,0-1.49,2.22",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7,347.68s11.6-2.77,12.39,0c.68,2.41-5.59-.42-11.78,6.34",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.81,303.33c9,14.53,21.67,43.12,21.67,43.12s-1.91,3.31,0,8.86c0,0-5,19.31,2.25,65.48,0,0,6.24,4,15.26-3,0,0,4.5-69.4,2.77-78.76s-18-71.18-18-71.18H105",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path-7)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.78,304.34s5.45,2.77,15.9,0,1.79,9,5.25,21.84,13.18,18.73,11.62,24.27-6.18,6.94-7.17,21.85,12.09,42.45,6.94,48.09-17.63-7.7-17.63-7.7L119.25,342Z",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M116.81,303.33c9,14.53,21.67,43.12,21.67,43.12s-1.91,3.31,0,8.86c0,0-5,19.31,2.25,65.48,0,0,6.24,4,15.26-3,0,0,4.5-69.4,2.77-78.76s-18-71.18-18-71.18H105",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.1,348.9c4.11-.62,9.36-1,9.15.86-.34,3.12-7.67-.05-12.13,5.2",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.38,349.76s.72-.16,1.83-.37",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169,169.72l.65-6.6s-1.3-6.87-.65-9.2,6.35-17.1,8.16-16.45-2.72,8.68-2.59,11c0,0,2.41.13,3,1.68,0,0,2.29.39,2.42,2.46a3.66,3.66,0,0,1,1.68,3.37c-.25,2.2-4.66,8.16-4.66,8.16l.26,8.55Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.66,158.57s-2.55-5-2.92-6.88c-.27-1.31.27-4,0-5.32-.62-3.05-4.89-11.44-4.89-11.44a2.31,2.31,0,0,0-.76-.9l-2.5,3.08h-6.78l-10.36,13.68,5.1,12.28-1.49,1.77c.91.9,1.49,1.42,1.49,1.42l-1.49,8.91,14.6,1.48L121,171h4.44a2.26,2.26,0,0,0,2.26-2.26V161l2-.58A1.37,1.37,0,0,0,130.66,158.57Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.35,154.12c5.88,8.66,12.2,12.14,12.2,12.14l2.49-6.19s-5-.53-4.25-5.39c1.17-7.17,7-.72,7-.72l1.26-5.54s3.11-3.34,2.89-4.51a20.42,20.42,0,0,0-.66-2.51s11.25-10.71,10.06-16.68c0,0-9.37,1.9-20.55,4C92.18,131.18,88.71,144.36,95.35,154.12Z",
    className: "svg-bg",
    style: {
      fill: "#3F3D56",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.48,171s-7.83-1.33-10.82-5-.61.26.79,2.51C118.45,173.32,121,171,125.48,171Z",
    className: "svg-bg",
    style: {
      fill: "#3F3D56"
    },
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.66,159.74a5,5,0,0,0,4.38,1.65",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.36,150.17c0,.7-.26,1.26-.59,1.26s-.58-.56-.58-1.26.26-1.26.58-1.26S126.36,149.48,126.36,150.17Z",
    className: "svg-bg",
    style: {
      fill: "#3F3D56"
    },
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.25,146.49a3.5,3.5,0,0,0-4,2.12",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.43,179.06s0-6.84,11.79-5.78c14.33,1.3,20.11,8.64,20.11,8.64Z",
    className: "svg-accent",
    style: {
      fill: "rgb(0, 109, 195)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    fill: "rgba(0,109,195,1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.55,177.83c8.93,1,24.5,3.15,23.57,27.16s-4.39,62.84-4.39,62.84S96.07,286.91,91,269.21c0,0,2.32-20-5.08-51.13S81.87,173.5,121.55,177.83Z",
    className: "svg-bg",
    style: {
      fill: "#3F3D56"
    },
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path-8)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.38,245.17s-5.83,1.4-23.69-8.32c-28-15.27-31.14-37.68-39-34s7.77,75.95,7.77,75.95l29,1.82h26.88Z",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M121.55,177.83c8.93,1,24.5,3.15,23.57,27.16s-4.39,62.84-4.39,62.84S96.07,286.91,91,269.21c0,0,2.32-20-5.08-51.13S81.87,173.5,121.55,177.83Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70,235.2q-.75.18-1.59.45",
    style: {
      fill: "none",
      stroke: "#7f7f7f",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.38,235.65s-1.88-1.34-6-.72",
    style: {
      fill: "none",
      stroke: "#7f7f7f",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125,178.27s15.47.1,22.4,4.26c0,0,12.25-2.08,17.11,0l4.39-16.41s5.78-2.78,8.55,1.38c0,0,2.08,25-1.38,27.05s-30.94,8.32-30.94,8.32S127.58,197.59,125,178.27Z",
    className: "svg-bg",
    style: {
      fill: "#3F3D56"
    },
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path-9)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145,198.63s-.81-6.43,11-5.6,21,1.06,22.17-4.49,14.12-15.15,10,2.82l-4.17,18L159.16,211Z",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M125,178.27s15.47.1,22.4,4.26c0,0,12.25-2.08,17.11,0l4.39-16.41s5.78-2.78,8.55,1.38c0,0,2.08,25-1.38,27.05s-30.94,8.32-30.94,8.32S127.58,197.59,125,178.27Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.38,183.76a15.81,15.81,0,0,1,3.4,3.85",
    style: {
      fill: "none",
      stroke: "#7f7f7f",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.88,182.69a2.55,2.55,0,0,1,1.09.24",
    style: {
      fill: "none",
      stroke: "#7f7f7f",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.59,211c-.54-5.18-2-14.69-1.43-21.27",
    style: {
      fill: "none",
      stroke: "#7f7f7f",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5,198.63s2.7,16,4,16",
    style: {
      fill: "none",
      stroke: "#7f7f7f",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 91.21,
    y1: 258.05,
    x2: 91.21,
    y2: 267.03,
    style: {
      fill: "none",
      stroke: "#7f7f7f",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.45,280.64s1.45,10.15,5.91,16.42",
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.64,164.23l-1,3.72s6.76-1.6,12.74,1.61l-.61-4.35S174.9,162.32,167.64,164.23Z",
    className: "svg-accent",
    style: {
      fill: "rgb(0, 109, 195)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    fill: "rgba(0,109,195,1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.71,260.13c-4.87,2.16-14.53,4.06-33.5,2.19",
    style: {
      fill: "none",
      stroke: "#7f7f7f",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.59,256.15a5.36,5.36,0,0,1-1.92,2.26",
    style: {
      fill: "none",
      stroke: "#7f7f7f",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149,183l7.89,4.88",
    style: {
      fill: "none",
      stroke: "#7f7f7f",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.68,224.07a38.73,38.73,0,0,0,9-21",
    style: {
      fill: "none",
      stroke: "#7f7f7f",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.08,222.62a64.75,64.75,0,0,1-23.42,17.12",
    style: {
      fill: "none",
      stroke: "#7f7f7f",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136,217.54c-.75,1.08-1.54,2.13-2.37,3.16",
    style: {
      fill: "none",
      stroke: "#7f7f7f",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.41,213.92c-.38.64-.78,1.26-1.18,1.88",
    style: {
      fill: "none",
      stroke: "#7f7f7f",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.18,252a56.63,56.63,0,0,0,32.37,4.43",
    style: {
      fill: "none",
      stroke: "#7f7f7f",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.25,127.82a16.76,16.76,0,0,0,2.94-1.65",
    style: {
      fill: "none",
      stroke: "#7f7f7f",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.89,151.43s-5.55-10.18.86-15.73c4.89-4.22,13.61-4.62,20.59-6.8",
    style: {
      fill: "none",
      stroke: "#7f7f7f",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.56,144.2a5.32,5.32,0,0,1,1.22-5.4c3.81-3.62,14.93-4,20.47-9.51",
    style: {
      fill: "none",
      stroke: "#7f7f7f",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.82,148.91a14.67,14.67,0,0,1-1.22-2",
    style: {
      fill: "none",
      stroke: "#7f7f7f",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlockPage);
export default __webpack_public_path__ + "static/media/unlock-page.ac2baf39634238c478e4681456d16680.svg";
export { ForwardRef as ReactComponent };